
$(document).ready(function () {
  // Attach the click event to elements with the class 'remove-items'
  $(".remove-items").on("click", function (event) {
    console.log('workingcartjs ======== remove-items');
    // Prevent the default action (if any) for the click event
    event.preventDefault();

    // Add a timeout before calling the ClearCartDrawerSample function
    setTimeout(function () {
      console.log("waiting for timeout.")
      ClearCartDrawerSample();
    }, 500); // Timeout set to 1000ms (1 second). Adjust as needed.
  });
});

function ClearCartDrawerSample() {
  try {
    // Make the AJAX call synchronous
    $.ajax({
      type: "GET",
      url: '/cart.js',
      dataType: 'json',
      async: false, 
      success: function(cart) {
        console.log("cart-totalprice === === " + cart.total_price);
        if (cart.total_price <= 0) {
          $(".checkout-btn").prop("disabled", true);
          // Clear the cart using another $.ajax call
          $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            async: false, 
            success: function() {
              // Hard refresh the page immediately
              var url = window.location.href;
              
              if(url.indexOf("/cart") > -1){
                location.reload(); 
              }else{
                  updateCart();
              }
              
            },
            error: function(XMLHttpRequest, textStatus) {
              updateCart(); 
              console.error('AJAX Error:', textStatus, XMLHttpRequest);
            }
          });
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        console.error('Failed to fetch cart JSON:', textStatus, XMLHttpRequest);
      }
    });
  } catch (error) {
    console.error('Error in ClearCartDrawerSample:', error);
  }
}



var drawerHandle = '';
function removecombo(){
  $.getJSON('/cart.js', function(cart) {
    var var_id = '';
    var spent = 0;
     $('#main-cart-items .cart-item').each(function(){
       // console.log("remove----hits");
       var pro_id = $(this).attr('data-id');
       var enable = $(this).attr('data-combo-spend-freep');
       var amount = $(this).attr('data-combo-invest');
       if(enable=="true"){
          var_id = pro_id;
          spent = amount*100 ;
       }
       // console.log(var_id+"==="+spent);
    });
   // console.log(cart.total_price);
  //  console.log(window.theme.Currency.formatMoney(cart.total_price, window.theme.shopSettings.moneyFormat)< window.theme.Currency.formatMoney(spent, window.theme.shopSettings.moneyFormat));
    if(parseFloat(cart.total_price) < parseFloat(spent)){
       $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          async: false,
          data:{
            id: var_id,
            quantity: 0
          },
          dataType: 'json',
          success: function(){
            updateCart();
            // window.location.assign('/cart');
          },
          error: function(error){
            console.log(error);   
          },
        });
  
      return false;
   }
     if( cart.total_price <= 0){
          // console.log("Zeroooo----Hits");
         $(".checkout-btn").prop("disabled", true);
          // $('.checkout-btn').after('<p style="color:red;">You must add merchandise before you can proceed to checkout.</p>');
           setTimeout(function(){
             $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              data: '',
              dataType: 'json',
              success: function() { 
                updateCart();
                // location.reload();
                ClearCartDrawer()
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log(textStatus);
              }
            });
          return false;
        },100);
      }
        validateMaxfreeSample();
  });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
       // removecombo();
       AddFreeGift();
       setTimeout(function () {
      console.log("waiting for timeout.")
      ClearCartDrawerSample();
         updateCart();
    }, 1000);
       
           
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
     var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
      // AddFreeGift();
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
        var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
     ClearCartDrawer();
     
    // }
    // removecombo();
    AddFreeGift();
    ClearCartDrawer();
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'mini-cart__shippingbar',
        section: document.getElementById('mini-cart__shippingbar')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
      var url = window.location.href;
        ClearCartDrawer();
      // console.log(url.indexOf("/cart"));
      if(url.indexOf("/cart") > -1){
      updateCart();
      }
        // removecombo();
        return response.text();
      })
      .then((state) => {
        validateMaxfreeSample();
                var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
    //     removecombo();
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
    validateMaxfreeSample();
     var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
    // removecombo();
    ClearCartDrawer();
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
    // removecombo();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

    //   setTimeout(() => {
    //     cartStatus.setAttribute('aria-hidden', true);
    //   var url = window.location.href;
    //   // console.log(url.indexOf("/cart"));
    //  if(url.indexOf("/cart") > -1){
    // updateCart();
    //  }
    //     removecombo();
    //   }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
    // }
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    // if(url.indexOf("/cart") > -1){
    // updateCart();
       
    // }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);


function ClearCartDrawer(){
  $.getJSON('/cart.js', function(cart) {
    console.log(cart.total_price)
             if( cart.total_price <= 0){
             $(".checkout-btn").prop("disabled", true);
               $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function() {
                $(".mini-cart__empty").show();
                $(".mini-cart__footer").hide();
                $('.mini-cart').addClass('is-empty');
                   updateCart();
                  
                   console.log("pause......here");
                },
                error: function(XMLHttpRequest, textStatus) {
                  updateCart();
                  console.log('error');
                  
                }
              });
                

            return false;
             }
  })
}


// function updateCart(){
//     setTimeout(function (){
//     var url = window.location.href;
//     // console.log(url.indexOf("/cart"));
//     if(url.indexOf("/cart") > -1){
//       window.location.href = "/cart";
//       return false;
//        $.ajax({
//           url: '/cart?section_id=main-cart-footer',
//           async: false,
//           type: 'GET',
//           dataType: 'html',
//           success:function(carthtml) {
//             console.log(carthtml)
//             $('#main-cart-footer').html($(carthtml).find('#main-cart-footer').html());
//             validateMaxfreeSample();
//           }
//         });
//       $.ajax({
//           url: '/cart?section_id=main-cart-items',
//           async: false,
//           type: 'GET',
//           dataType: 'html',
//           success:function(carthtml) {
//             $('#main-cart-items').html($(carthtml).find('#main-cart-items').html());
//             validateMaxfreeSample();
//           }
//         });
//       $.ajax({
//           url: '/cart?section_id=mini-cart__shippingbar',
//           async: false,
//           type: 'GET',
//           dataType: 'html',
//           success:function(carthtml) {
//             $('#mini-cart__shippingbar').html($(carthtml).find('#mini-cart__shippingbar').html());
//             validateMaxfreeSample();
//           }
//         });
//      slideFreeGift();

//      }else{
//       $("div.loader-cart-drwer-jtpl").addClass("loading");
//       $("div.loader-cart-drwer-jtpl.loading").show();
//        $.ajax({
//           url: '/pages/contact-us?section_id=mini-cart',
//           async: false,
//           type: 'GET',
//           dataType: 'html',
//           success:function(carthtml) {
//             $("form div.mini-cart__inner").hide();
//             // console.log(carthtml);
//             $('#main-cart-items').html($(carthtml).find('#main-cart-items').html());
//             $('#mini-cart__shippingbar').html($(carthtml).find('#mini-cart__shippingbar').html());
//             $('.mini-cart__footer').html($(carthtml).find('.mini-cart__footer').html());
//             validateMaxfreeSample();
//             $("form div.mini-cart__inner").show();
          
           
//             if($('.mini-cart__empty').is(':visible')){
//               $('.mini-cart__messages.cart-message-jtpl').hide();
//               $(".mini-cart__main").hide();
//               $(".free-sample-main-section").hide();
//             }else{
//               $(".mini-cart__main").show();
//                $(".free-sample-main-section").show();
//             }
//             if ($('.mini-cart__empty').css('display') === 'block') {
//               $('.mini-cart__messages.cart-message-jtpl').hide();
//             }
//              $("div.loader-cart-drwer-jtpl").removeClass("loading");
//             $("div.loader-cart-drwer-jtpl").hide();
//             var divCount = $(".flickity-slider .total-modalninfo").length;
//               if (divCount < 2) {
//                 $(".free-sample-products").addClass("arrow-disabled");
//               }else {
//                 $(".free-sample-products").removeClass("arrow-disabled");
//               }
//             //   var cart_count=$(carthtml).find('.cart-item-count').attr('data-count');
//             // if($('.header__icon--cart .cart-count-bubble').length > 0){
//             //   $('.header__icon--cart .cart-count-bubble').text(cart_count);
//             // }else{
//             //   $('.header__icon--cart').append(`<span class='cart-count-bubble'>${cart_count}</span>`); 
//             // }
            
//           }
//         });
//       }
//       validateMaxfreeSample();
//      slideFreeGift();
//        cartBubble();
//     }, 500);
//   enableSlider();
//   return false;
// }